// extracted by mini-css-extract-plugin
export default {"wizard_separator":"WizardSeparator_wizard_separator__AzuED","wizard_separator__text":"WizardSeparator_wizard_separator__text__+xD3L","spin":"WizardSeparator_spin__XuFL4"};